import './newsletter.scss';

const NewsletterSection = () => {
    return (
        <div className="newsletter">

            <div className='info'>

                <div className='title'>Subscribe to Newsletter</div>
                <div className='text'>Don’t miss out on any update, daily news on upcoming offers.</div>

            </div>


            <div>
                <div className='searchTab'>

                    <input className='input' placeholder=''></input>

                    <div className='placeholder'>
                        <div className='text'>Enter Your E-mail</div>
                    </div>

                    <button className='btn'>Subscribe</button>

                </div>

            </div>



        </div>
    )
}


export default NewsletterSection;